export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';// all caps indicate here as unchange variable 
export const TIMEOUT_SEC =  10;
export const RES_PER_PAGE = 10;
export const KEY = '3601c9ab-8122-4445-a002-92314dab530e';
export const MODAL_CLOSE_SEC = 2.5;